var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Distribution" } },
        [
          _c(
            "Accord",
            { attrs: { title: "Site and depot locations" } },
            [
              _c("DistributionMap", {
                attrs: { "chart-name": "distributionMap" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("Accord", { attrs: { title: "Supply plans" } }, [
            _c("p", [
              _vm._v(
                "\n                    Supply plans determines dun requests and available stock depots and sites. Download all supply plands that has been used/generated.\n                "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "right",
                on: { click: _vm.onDownloadSupplyPlansClick },
              },
              [_vm._v("Download supply plans in excel")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Shipments" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "distributionShipments",
                  settings: _vm.shipmentSettings,
                  buttonLoad: true,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "right",
                  on: { click: _vm.onDownloadShipmentsClick },
                },
                [_vm._v("Download all shipments in excel")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "DUN Request" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "distributionDunRequest",
                  settings: _vm.dunRequestSettings,
                  buttonLoad: true,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "right",
                  on: { click: _vm.onDownloadDunRequestsClick },
                },
                [_vm._v("Download all dun requests in excel")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }